"use client";
import Image from "next/image";
import React from "react";

import { useTranslation } from 'react-i18next';

export default function HomeMusica() {
  const { t } = useTranslation('music');

    return (
      <>
        <div className="container position-relative pt-100">
          <div className="row">
            <div className="mb-30 wow fadeInUp">
              <a
                href="https://www.youtube.com/watch?v=qMHyg6V4tR0"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("play_on_youtube", { name: "Aaliyah" })}
                className="block"
              >
                <Image
                  src="/music/album_aliyah.jpg"
                  width={1290}
                  height={827}
                  quality={60}
                  loading="lazy"
                  alt=""
                />
              </a>
            </div>
            <p className="text-gray" dangerouslySetInnerHTML={{__html: t('first_album_p1')}} />
            <p className="text-gray" dangerouslySetInnerHTML={{__html: t('first_album_p2')}} />
          </div>
        </div>
        <div className="container position-relative pt-5 pt-md-5">
          <div className="row">
            <div className="col-lg-6 d-flex align-items-center order-2 order-md-1 pt-4 pt-md-1">
              <div className="row mb-sm-30 col-md-10">
                <p className="text-gray text-justify" dangerouslySetInnerHTML={{__html: t('flashbulb_memory')}} />
              </div>
            </div>
            <div
              className="col-lg-6 d-flex wow fadeInLeft order-1 order-md-2"
              data-wow-delay="0.55s"
              data-wow-offset={275}
            >
              <div className="tab-content services-content">
                <div
                  className="tab-pane show fade active align-items-center d-flex"
                  id="services-item-1"
                  role="tabpanel"
                >
                  <a
                    href="https://www.youtube.com/watch?v=c8zOTe9mpKo"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={t("play_on_youtube", { name: "Flashbulb Memory" })}
                    className="block"
                  >
                    <Image
                      width={945}
                      height={500}
                      quality={60}
                      src="/music/album_flashbulb.jpg"
                      alt="Brian"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container position-relative pt-3 pt-md-5">
          <div className="row">
            <div className="col-lg-6 d-flex align-items-center order-2 order-md-1 pt-4 pt-md-1">
              <div className="row mb-sm-30 col-md-10">
                  <p className="text-gray text-justify" dangerouslySetInnerHTML={{__html: t('dragon_ball')}} />
              </div>
            </div>
            <div
              className="col-lg-6 d-flex wow fadeInLeft order-1 order-md-2"
              data-wow-delay="0.55s"
              data-wow-offset={275}
            >
              <div className="tab-content services-content">
                <div
                  className="tab-pane show fade active align-items-center d-flex"
                  id="services-item-1"
                  role="tabpanel"
                >
                  <a
                    href="https://www.youtube.com/watch?v=wzE3FfoaAV4"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={t("play_on_youtube", { name: "Dragon Ball" })}
                    className="block"
                  >
                    <Image
                      width={945}
                      height={300}
                      quality={60}
                      src="/music/album_dragon_ball.jpg"
                      alt="Brian"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
  );
}